module.exports = function (name, options) {
  if (name in page_state.form_data) {
    return options.fn(this);
  } else {
    return options.inverse(this);
  }
};
